(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7bb9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7bb9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iCMTj", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d8f1b35e99de56fe$export$6503ec6e8aabbaf; }, function (v) { return $d8f1b35e99de56fe$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $d8f1b35e99de56fe$export$f7ad0328861e2f03; }, function (v) { return $d8f1b35e99de56fe$export$f7ad0328861e2f03 = v; });
var $d8f1b35e99de56fe$export$6503ec6e8aabbaf;
var $d8f1b35e99de56fe$export$f7ad0328861e2f03;
"use strict";
var $d8f1b35e99de56fe$var$mapping = new Map();
function $d8f1b35e99de56fe$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d8f1b35e99de56fe$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d8f1b35e99de56fe$var$resolve(id) {
    var resolved = $d8f1b35e99de56fe$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d8f1b35e99de56fe$export$6503ec6e8aabbaf = $d8f1b35e99de56fe$var$register;
$d8f1b35e99de56fe$export$f7ad0328861e2f03 = $d8f1b35e99de56fe$var$resolve;

});

parcelRegister("59rV1", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $3c037310ec975992$export$bdfd709ae4826697; }, function (v) { return $3c037310ec975992$export$bdfd709ae4826697 = v; });
var $3c037310ec975992$export$bdfd709ae4826697;
var $3c037310ec975992$export$c9e73fbda7da57b6;
var $3c037310ec975992$export$5a759dc7a1cfb72a;
"use strict";
var $3c037310ec975992$var$bundleURL = {};
function $3c037310ec975992$var$getBundleURLCached(id) {
    var value = $3c037310ec975992$var$bundleURL[id];
    if (!value) {
        value = $3c037310ec975992$var$getBundleURL();
        $3c037310ec975992$var$bundleURL[id] = value;
    }
    return value;
}
function $3c037310ec975992$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $3c037310ec975992$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $3c037310ec975992$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $3c037310ec975992$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$3c037310ec975992$export$bdfd709ae4826697 = $3c037310ec975992$var$getBundleURLCached;
$3c037310ec975992$export$c9e73fbda7da57b6 = $3c037310ec975992$var$getBaseURL;
$3c037310ec975992$export$5a759dc7a1cfb72a = $3c037310ec975992$var$getOrigin;

});

var $7995c8ce11c8e64c$exports = {};


(parcelRequire("iCMTj")).register((parcelRequire("59rV1")).getBundleURL("eWlGV"), JSON.parse('["eWlGV","index.fda0d22a.js","9tgix","logo.94966943.png","24mX7","01_InitContent.2c689cf2.js","5Id8J","01_InitContent.5c624736.js","8M4Rx","02_PrestartContent.86b18eac.js","1guHK","02_PrestartContent.b0cb2dd7.js","bCS9b","phone_rotate_right.8eb0b571.png","fSHvD","phone_rotate_left.8c226e05.png","85xKo","phonerotate.dfe4a692.png","9yEwB","startRecording.36e52ca1.js","9dJyE","profiler.5057717d.js","gBqIe","03_StartContent.027485c3.js","hmU67","04_DemographicsContent.749f789f.js","5zWzY","04_DemographicsContent.364b5bea.js","el1TU","04_DemographicsContent.85a521bb.css","7Obas","05_InstructionsContent.b4fb475b.js","aCTQK","glassesCrossOut.4c7bb343.png","1Es21","man.e81cbbd5.png","blTtQ","still.972fa517.png","2E5Lf","focus.e22d4c5d.svg","5sCHe","restSurface.e5cdf14e.png","cuv3h","lighting.b8742489.png","38Yql","06_SetupContent.5c6bfe95.js","2wM9C","StudyContent.bb76ce04.js","4hnZn","thumbsUp.bf970f25.png","830oM","Pinterest.d5700fdc.js","lpnUd","Instagram.108ce6cd.js","kVL6j","Facebook.8310424f.js","84CLI","Snapchat.5e15e84f.js","cyQed","TikTok.ffe732fd.js","bTfYC","Gmail.20859551.js","fDnuZ","Twitter.062c4c1b.js","6r1vv","Music.98fffe75.js","jvRdo","Article.37994e84.js","g4att","Video.9a6656e3.js","d5ClV","Videoland.adcc4f98.js","uhsoC","ITVX.2b68c219.js","9Putv","Tencent.ca3dbfa5.js","1hT6K","Iq.76267243.js","hb8CL","Xiao.b51969fb.js","agZo6","Douyin.328c8f8f.js","1Cawg","Trainline.ce2b4656.js","iDvhe","Uber.f5ac74d4.js","hhaGu","UberEats.d5973520.js","k5seE","YouTubeShorts.411effcd.js","h2ue8","StudyContent.7c56f4db.css","3iz98","CompletionContent.2ad31f83.js","gUsMD","CompletionContent.5202e663.js","cyXF5","ErrorContent.ce32e4e4.js","lkjFQ","InvalidContent.e97d5a27.js","2CEqD","PreviewContent.72de6404.js","gouHw","RestoreContent.4b7dd537.js","5vW1a","LandingContent.734ee546.js","2Wd4h","index.00c42508.css"]'));

})();
//# sourceMappingURL=index.runtime.d1c94fe2.js.map
